"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.commands = exports.StopDispense = exports.StartDispense = exports.StopRemoteSession = exports.PingRemoteSession = exports.StartRemoteSession = void 0;
const effect_1 = require("effect");
const Remote = __importStar(require("./remote"));
const NAMESPACE = 'Culligan.Device.Class.Pelican2.Command';
class StartRemoteSession extends effect_1.Schema.Class(`${NAMESPACE}.StartRemoteSession`)({
    command: effect_1.Schema.tag('remoteSession.start'),
    params: effect_1.Schema.propertySignature(effect_1.Schema.Struct({
        otp: effect_1.Schema.propertySignature(Remote.Otp),
    })),
}, {
    identifier: `${NAMESPACE}.StartRemoteSession`,
    title: 'Start Remote Session',
    description: 'Commands the device to initiate a remote session.',
}) {
}
exports.StartRemoteSession = StartRemoteSession;
class PingRemoteSession extends effect_1.Schema.Class(`${NAMESPACE}.PingRemoteSession`)({
    command: effect_1.Schema.tag('remoteSession.ping'),
    params: effect_1.Schema.propertySignature(effect_1.Schema.Struct({
        otp: effect_1.Schema.propertySignature(Remote.Otp),
        order: effect_1.Schema.optionalWith(Remote.Order, { exact: true, as: 'Option' }),
    })),
}, {
    identifier: `${NAMESPACE}.PingRemoteSession`,
    title: 'Ping Remote Session',
    description: 'Keeps a remote session alive ' +
        'and synchronizes the selections made on the remote with the unit.',
}) {
}
exports.PingRemoteSession = PingRemoteSession;
class StopRemoteSession extends effect_1.Schema.Class(`${NAMESPACE}.StopRemoteSession`)({
    command: effect_1.Schema.tag('remoteSession.stop'),
    params: effect_1.Schema.propertySignature(effect_1.Schema.Struct({
        otp: effect_1.Schema.propertySignature(Remote.Otp),
    })),
}, {
    identifier: `${NAMESPACE}.StopRemoteSession`,
    title: 'Stop Remote Session',
    description: 'Commands the device to terminate a remote session.',
}) {
}
exports.StopRemoteSession = StopRemoteSession;
class StartDispense extends effect_1.Schema.Class(`${NAMESPACE}.StartDispense`)({
    command: effect_1.Schema.tag('dispense.start'),
    params: effect_1.Schema.propertySignature(effect_1.Schema.Struct({
        otp: effect_1.Schema.propertySignature(Remote.Otp),
        order: effect_1.Schema.propertySignature(Remote.Order),
    })),
}, {
    identifier: `${NAMESPACE}.StartDispense`,
    title: 'Start Dispense',
    description: 'Commands the device to start dispensing water',
}) {
}
exports.StartDispense = StartDispense;
class StopDispense extends effect_1.Schema.Class(`${NAMESPACE}.StopDispense`)({
    command: effect_1.Schema.tag('dispense.stop'),
    params: effect_1.Schema.propertySignature(effect_1.Schema.Struct({
        otp: effect_1.Schema.propertySignature(Remote.Otp),
    })),
}, {
    identifier: `${NAMESPACE}.StopDispense`,
    title: 'Stop Dispense',
    description: 'Commands the device to stop an ongoing dispense',
}) {
}
exports.StopDispense = StopDispense;
exports.commands = [
    StartRemoteSession,
    PingRemoteSession,
    StopRemoteSession,
    StartDispense,
    StopDispense,
];
//# sourceMappingURL=command.js.map